import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ViewBanner() {
  const { banner_id } = useParams();

  const [formData, setFormData] = useState({
    bannerType: '',
    supplierId: '',
    website: '',
    isActive: false,
  });

  const [suppliers, setSuppliers] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  // Fetch banner data and suppliers when component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [bannerRes, supplierRes] = await Promise.all([
          axios.get(`https://backend-zkgn.onrender.com/:3002/api/banners/${banner_id}`),
          axios.get('https://backend-zkgn.onrender.com/:3002/api/suppliers'),
        ]);

        const banner = bannerRes.data;
        setFormData({
          bannerType: banner.banner_type || '',
          supplierId: banner.supplier_id || '',
          website: banner.website || '',
          isActive: banner.isActive === 1, // if stored as TINYINT(1)
        });
        setImagePreview(`https://backend-zkgn.onrender.com/:3002/uploads/${banner.banner_image_link}`);
        setSuppliers(supplierRes.data);
        console.log('Banner response:', bannerRes.data);
        console.log('Supplier response:', supplierRes.data);
      } catch (err) {
        console.error('Error fetching banner/suppliers:', err);
        toast.error('Failed to load banner data');
      }
      

    };
      
    fetchData();
  }, [banner_id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setImagePreview(null);
    setImageFile(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append('bannerType', formData.bannerType);
    payload.append('supplierId', formData.supplierId);
    payload.append('website', formData.website);
    payload.append('isActive', formData.isActive ? 1 : 0);
    if (imageFile) payload.append('bannerImage', imageFile);

    try {
      await axios.put(`https://backend-zkgn.onrender.com/api/banners/${banner_id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      toast.success('Banner updated successfully!');
    } catch (err) {
      console.error('Error updating banner:', err);
      toast.error('Failed to update banner');
    }
  };

  return (
    <div className="container my-4">
      <ToastContainer />
      <h3 className="mb-4">View / Edit Banner Details</h3>
      <form onSubmit={handleSubmit} className="row g-3">
        {/* Banner Type */}
        <div className="col-md-6">
          <label className="form-label">Banner Type</label>
          <select
            className="form-select"
            name="bannerType"
            value={formData.bannerType}
            onChange={handleChange}
          >
            <option value="">-- Select Banner Type --</option>
            <option value="Home Page Banner">Home Page Banner</option>
            <option value="Supplier Banner">Supplier Banner</option>
            <option value="Side Banner">Side Banner</option>
            <option value="InSide Banner">InSide Banner</option>
          </select>
        </div>

        {/* Supplier */}
        <div className="col-md-6">
          <label className="form-label">Supplier Name</label>
          <select
            className="form-select"
            name="supplierId"
            value={formData.supplierId}
            onChange={handleChange}
          >
            <option value="">-- Select Supplier --</option>
            {suppliers.map((supplier) => (
              <option key={supplier.supplier_id} value={supplier.supplier_id}>
                {supplier.supplier_name}
              </option>
            ))}
          </select>
        </div>

        {/* Website */}
        <div className="col-md-6">
          <label className="form-label">Website</label>
          <input
            type="url"
            name="website"
            className="form-control"
            value={formData.website}
            onChange={handleChange}
            placeholder="https://example.com"
          />
        </div>

        {/* Is Active */}
        <div className="col-md-6 d-flex align-items-center">
          <div className="form-check mt-3">
            <input
              type="checkbox"
              className="form-check-input"
              name="isActive"
              checked={formData.isActive}
              onChange={handleChange}
              id="isActive"
            />
            <label className="form-check-label" htmlFor="isActive">
              Is Active
            </label>
          </div>
        </div>

        {/* Image Upload */}
        <div className="col-md-6">
          <label className="form-label">Banner Image</label>
          {imagePreview && (
            <div className="mb-2">
              <img
                src={imagePreview}
                alt="Banner Preview"
                className="img-fluid border rounded"
                style={{ maxHeight: '200px' }}
              />
              <div className="mt-2">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger me-2"
                  onClick={removeImage}
                >
                  Remove Image
                </button>
              </div>
            </div>
          )}
          <input
            type="file"
            accept="image/*"
            className="form-control"
            onChange={handleImageChange}
          />
        </div>

        {/* Submit */}
        <div className="col-12 text-end mt-4">
          <button type="submit" className="btn btn-success px-4">
            Update Banner Details
          </button>
        </div>
      </form>
    </div>
  );
}

export default ViewBanner;
